import { SP } from "./namespace";
import { TAU, clamp, rgba, shade } from "../client";
SP.drawIceShard = function(c, r, col, t, ang) {
  c.save();
  c.globalCompositeOperation = "lighter";
  c.globalAlpha = 0.3; c.fillStyle = col;
  c.beginPath(); c.arc(0, 0, r * 1.9, 0, TAU); c.fill();
  c.restore();
  c.save();
  c.rotate(t * 3 + ang);
  const R = r * 1.8;
  c.fillStyle = "rgba(214,246,255,0.95)";
  c.strokeStyle = col; c.lineWidth = 1.5;
  c.beginPath();
  c.moveTo(0, -R); c.lineTo(r * 0.85, -r * 0.3); c.lineTo(r * 0.6, R * 0.7);
  c.lineTo(-r * 0.6, R * 0.7); c.lineTo(-r * 0.85, -r * 0.3); c.closePath();
  c.fill(); c.stroke();
  c.restore();
}

SP.drawGlacierSpear = function(c, r, col, ang) {
  c.save();
  c.globalCompositeOperation = "lighter";
  c.globalAlpha = 0.28; c.fillStyle = col;
  c.beginPath(); c.arc(0, 0, r * 2, 0, TAU); c.fill();
  c.restore();
  c.save();
  c.rotate(ang);
  c.fillStyle = "rgba(200,238,255,0.95)";
  c.strokeStyle = col; c.lineWidth = 2;
  c.beginPath();
  c.moveTo(r * 2.1, 0); c.lineTo(r * 0.2, -r * 0.85);
  c.lineTo(-r * 1.7, -r * 0.45); c.lineTo(-r * 1.7, r * 0.45);
  c.lineTo(r * 0.2, r * 0.85); c.closePath();
  c.fill(); c.stroke();
  c.restore();
}

SP.drawBlade = function(c, r, col, t) {
  c.save();
  c.rotate(t * 17);
  c.globalCompositeOperation = "lighter";
  c.strokeStyle = col; c.globalAlpha = 0.35; c.lineWidth = r * 0.9; c.lineCap = "round";
  c.beginPath(); c.arc(0, 0, r * 1.6, 0, Math.PI * 1.4); c.stroke();
  c.lineCap = "butt"; c.globalAlpha = 1;
  c.fillStyle = col;
  c.beginPath();
  c.arc(0, 0, r * 1.8, -0.5, 1.0);
  c.arc(0, 0, r * 1.0, 1.0, -0.5, true);
  c.closePath(); c.fill();
  c.restore();
}

SP.drawOrbRing = function(c, r, col, t) {
  c.save();
  c.globalCompositeOperation = "lighter";
  c.fillStyle = col; c.globalAlpha = 0.3;
  c.beginPath(); c.arc(0, 0, r * 1.9, 0, TAU); c.fill();
  c.globalAlpha = 0.85;
  c.beginPath(); c.arc(0, 0, r, 0, TAU); c.fill();
  for (let i = 0; i < 3; i++) {
    const a = t * 6 + i * TAU / 3;
    c.beginPath(); c.arc(Math.cos(a) * r * 2, Math.sin(a) * r * 1.1, r * 0.32, 0, TAU); c.fill();
  }
  c.restore();
}

SP.drawUnstable = function(c, r, col, t) {
  c.save();
  c.globalCompositeOperation = "lighter";
  c.fillStyle = col; c.globalAlpha = 0.45 + 0.2 * Math.sin(t * 30);
  c.beginPath(); c.arc(0, 0, r * 1.7, 0, TAU); c.fill();
  c.globalAlpha = 0.9;
  c.beginPath(); c.arc(0, 0, r * 0.8, 0, TAU); c.fill();
  c.restore();
}

SP.drawHelix = function(c, r, col, t, ang) {
  c.save();
  c.rotate(ang);
  c.globalCompositeOperation = "lighter";
  c.strokeStyle = col; c.lineWidth = 2;
  for (let s = -1; s <= 1; s += 2) {
    c.beginPath();
    for (let i = 0; i <= 14; i++) {
      const f = i / 14, x = (f - 0.5) * r * 4, y = Math.sin(f * Math.PI * 3 + t * 14) * r * 0.9 * s;
      i ? c.lineTo(x, y) : c.moveTo(x, y);
    }
    c.stroke();
  }
  c.fillStyle = "#fff"; c.beginPath(); c.arc(0, 0, r * 0.5, 0, TAU); c.fill();
  c.restore();
}

SP.drawWebOrb = function(c, r, col, t) {
  c.save();
  c.globalCompositeOperation = "lighter";
  c.fillStyle = col; c.globalAlpha = 0.35;
  c.beginPath(); c.arc(0, 0, r * 1.6, 0, TAU); c.fill();
  c.globalAlpha = 0.85;
  c.beginPath(); c.arc(0, 0, r * 0.8, 0, TAU); c.fill();
  c.rotate(t * 2);
  c.strokeStyle = col; c.lineWidth = 1.5;
  for (let i = 0; i < 6; i++) {
    const a = i / 6 * TAU;
    c.beginPath(); c.moveTo(0, 0); c.lineTo(Math.cos(a) * r * 2, Math.sin(a) * r * 2); c.stroke();
  }
  c.restore();
}

SP.drawCrystalBall = function(c, r, col) {
  c.save();
  c.globalCompositeOperation = "lighter";
  c.fillStyle = col; c.globalAlpha = 0.35;
  c.beginPath(); c.arc(0, 0, r * 1.8, 0, TAU); c.fill();
  c.restore();
  const g = c.createRadialGradient(-r * 0.3, -r * 0.3, r * 0.1, 0, 0, r);
  g.addColorStop(0, "#fff"); g.addColorStop(0.45, col); g.addColorStop(1, shade(col, 0.5));
  c.fillStyle = g;
  c.beginPath(); c.arc(0, 0, r, 0, TAU); c.fill();
}

SP.drawFrozenOrb = function(c, r, col, t) {
  c.save();
  c.globalCompositeOperation = "lighter";
  c.globalAlpha = 0.25; c.fillStyle = col;
  c.beginPath(); c.arc(0, 0, r * 2.4, 0, TAU); c.fill();
  c.restore();
  c.save();
  c.rotate(t * 7);
  for (let i = 0; i < 8; i++) {
    c.save();
    c.rotate((i / 8) * TAU);
    c.fillStyle = "rgba(200,240,255,0.9)";
    c.beginPath();
    c.moveTo(0, -r * 1.6); c.lineTo(r * 0.22, -r * 0.9); c.lineTo(-r * 0.22, -r * 0.9);
    c.closePath(); c.fill();
    c.restore();
  }
  c.restore();
  c.fillStyle = "rgba(120,210,255,0.85)";
  c.beginPath(); c.arc(0, 0, r * 0.95, 0, TAU); c.fill();
}

SP.drawHook = function(c, r, col, ang) {
  c.save();
  c.rotate(ang + Math.PI / 2);
  c.strokeStyle = col; c.lineWidth = r * 0.5; c.lineCap = "round";
  c.beginPath(); c.arc(0, r * 0.3, r * 0.9, -Math.PI * 0.5, Math.PI * 0.9); c.stroke();
  c.fillStyle = "#fff6d0";
  c.beginPath(); c.moveTo(r * 0.9, r * 0.3); c.lineTo(r * 1.5, 0); c.lineTo(r * 1.1, r * 0.8); c.closePath(); c.fill();
  c.restore();
}

SP.drawProj = function(c, spellId, r, col, ang, t) {
  const core = /fire|meteor|firespray/i.test(spellId) ? "#fff0d0"
    : /drain/i.test(spellId) ? "#ffd0e0" : "#ffffff";
  switch (spellId) {
    case "freeze":
    case "frostspike": SP.drawIceShard(c, r, col, t, ang); break;
    case "icelance": SP.drawGlacierSpear(c, r, col, ang); break;
    case "boomerang": SP.drawBlade(c, r, col, t); break;
    case "homing": SP.drawOrbRing(c, r, col, t); break;
    case "splitter": SP.drawUnstable(c, r, col, t); break;
    case "swap": SP.drawHelix(c, r, col, t, ang); break;
    case "disable": SP.drawWebOrb(c, r, col, t); break;
    case "bouncer": SP.drawCrystalBall(c, r, col); break;
    case "hook":
    case "link": SP.drawHook(c, r, col, ang); break;
    case "frozenorb": SP.drawFrozenOrb(c, r, col, t); break;
    case "voidorb": SP.drawVoidOrb(c, r, col, t); break;
    default: SP.glowOrb(c, r, col, ang, core); break;
  }
}

SP.drawZone = function(c, z, t) {
  const pulse = 0.5 + 0.5 * Math.sin(t * 4 + z.phase);
  c.save();
  c.globalAlpha = z.alpha * (0.35 + 0.15 * pulse);
  c.strokeStyle = z.stroke || z.color;
  c.fillStyle = z.fill || rgba(z.color, 0.12);
  c.lineWidth = z.lineW || 2;
  c.beginPath(); c.arc(z.x, z.y, z.r, 0, TAU); c.fill(); c.stroke();
  if (z.core) {
    c.globalAlpha = z.alpha * 0.5;
    c.fillStyle = z.core;
    c.beginPath(); c.arc(z.x, z.y, z.r * 0.35, 0, TAU); c.fill();
  }
  c.restore();
}

SP.drawBeam = function(c, b, t) {
  const a = clamp(1 - b.t / b.life, 0, 1);
  c.save();
  c.globalCompositeOperation = "lighter";
  c.globalAlpha = a * 0.85;
  c.strokeStyle = b.color;
  c.lineWidth = b.width || 3;
  c.lineCap = "round";
  c.beginPath(); c.moveTo(b.x0, b.y0);
  if (b.mid) c.lineTo(b.mid[0], b.mid[1]);
  c.lineTo(b.x1, b.y1); c.stroke();
  c.globalAlpha = a * 0.35;
  c.lineWidth = (b.width || 3) * 3;
  c.stroke();
  c.restore();
}

SP.drawWall = function(c, w, t) {
  const a = clamp(w.alpha, 0, 1);
  c.save();
  c.globalCompositeOperation = "lighter";
  for (let i = 0; i < 5; i++) {
    const yy = w.y + (i - 2) * 14;
    c.globalAlpha = a * (0.35 + 0.2 * Math.sin(t * 8 + i));
    c.fillStyle = w.color;
    c.fillRect(w.x - w.thick / 2, yy - 6, w.thick, 12);
  }
  c.restore();
}

SP.drawDecoy = function(c, x, y, robeIdx, t, alpha) {
  c.save();
  c.globalAlpha = alpha;
  SP.drawWizard(c, x, y, robeIdx, 1, Math.sin(t * 3 + x) * 0.6, 13, 0);
  c.restore();
}
